import './styles.css';

export const ChartOrMessage = ({
  data,
  children,
  message = 'No data available',
}) => {
  const hasData =
    Array.isArray(data) &&
    data.length > 0 &&
    data.some((d) => typeof d.value === 'number' && d.value > 0);

  const hasDataCheckins =
    Array.isArray(data) &&
    data.some(
      (item) =>
        (typeof item.Checkins === 'number' && item.Checkins > 0) ||
        (typeof item.Impairments === 'number' && item.Impairments > 0),
    );

  if (!hasData && !hasDataCheckins) {
    return (
      <div className='noDataContainer'>
        <p className='noDataText'>{message}</p>
      </div>
    );
  }

  return children;
};
